import React, { useState } from "react";
import "./Tracking.css";

const TrackingResult = ({ trackingData }) => {
  const [showPod, setShowPod] = useState(false);
  if (!trackingData?.Data?.length) return null;

  const shipment = trackingData.Data[0];


  const currentStatus = shipment.Status;

  const statusSteps = [
    {
      status: "InTransit",
      title: "Softdata Upload",
      location: shipment.Origin_Name,
      date: shipment.bookdate
    },
    {
      status: "InTransit",
      title: "Picked Up",
      location: shipment.Origin_Name,
      date: shipment.bookdate
    },
    {
      status: "Manifested",
      title: "Accepted",
      location: shipment.Origin_Name,
      date: shipment.ManifestDate
    },
    {
      status: "Manifested",
      title: "In Transit",
      location: shipment.ManifestDestination,
      date: shipment.ManifestDate
    },
   {
  status: "Arrived At Hub",
  title: "At Destination",
  location: shipment.AtdestinationDt
    ? shipment.Destination_Name
    : "",
  date: shipment.AtdestinationDt || ""
},
   {
  status: "Delivered",
  title: "Delivered",
  location:
    shipment.Status === "Delivered"
      ? shipment.Destination_Name
      : "",
  date:
    shipment.Status === "Delivered"
      ? shipment.statusDt
      : ""
},




  ];
  const completedIndex = [...statusSteps]
    .map((step, index) => ({ ...step, index }))
    .filter(
      (step) =>
        step.status.toLowerCase() === currentStatus.toLowerCase()
    )
    .pop()?.index ?? -1;
  console.log("Current Status:", currentStatus);
  console.log("Completed Index:", completedIndex);
  return (
    <div className="tracking-wrapper">

      {/* HEADER */}

      <div className="tracking-header">
        <span>
          Tracking Details : {shipment.CNoteNo}
        </span>
      </div>


      <div className="sum-pog">


        {/* SUMMARY */}

        <div className="summary-box">

          <div className="summary-item">
            <span>Reference No</span>
            <span className="span2">{shipment.CNoteNo}</span >
          </div>

          <div className="summary-item">
            <span>Origin</span>
            <span className="span2">{shipment.Origin_Name}</span >
          </div>

          <div className="summary-item">
            <span>Destination</span>
            <span className="span2">
              {shipment.Destination_Name}
              {shipment.ReceiveredPincode ? `, ${shipment.ReceiveredPincode}` : ""}
            </span>
          </div>

          <div className="summary-item">
            <span>Service</span>
            <span className="span2">{shipment.Mode_Code}</span >
          </div>

          <div className="summary-item">
            <span>Booked On</span>
            <span className="span2">{shipment.bookdate}</span >
          </div>

          <div className="summary-item">
            <span>EDD</span>
            <span className="span2">{shipment.ExptDateDelivery}</span >
          </div>



        </div>

        {/* PROGRESS BAR */}
        <div className="pro-div">

          <div className="progress-container">
            {statusSteps.map((step, index) => (
              <div className="progress-step" key={index}>
                <div
                  className={`circle ${index <= completedIndex ? "active" : ""
                    }`}
                >
                  ✓
                </div>

                {index !== statusSteps.length - 1 && (
                  <div
                    className={`line ${index < completedIndex ? "line-active" : ""
                      }`}
                  />
                )}

                <div className="step-info">
                  <div className="step-title">{step?.title}</div>
                  <div className="step-location">{step?.location}</div>
                  <div className="step-date">{step?.date}</div>
                </div>
              </div>
            ))}
          </div>
          {shipment.Status === "Delivered" && <div className="summary-item status">
            <span>Status</span>
            <h4>{shipment.Status} ✅</h4>
            <small>{shipment.statusDt}</small>
          </div>}
        </div>

        <div style={{ marginTop: "15px" }}>
          <button
            onClick={() => setShowPod(!showPod)}
            style={{
              padding: "10px 15px",
              background: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            {showPod ? "Hide POD" : "View POD"}
          </button>
        </div>

        {showPod && shipment.ImageLink && (
          <div style={{ marginTop: "15px" }}>
            <img
              src={shipment.ImageLink}
              alt="POD"
              style={{
                maxWidth: "500px",
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "8px"
              }}
            />
          </div>
        )}

      </div>

      {/* <div className="tracking-tabs">
        <button className="tab active">Tracking History</button>
        <button className="tab">Record Communication</button>
        <button className="tab">Booking Details</button>
        <button className="tab">Address Details</button>
        <button className="tab">Dim/Item</button>
        <button className="tab">Rate Info / VAS</button>
        <button className="tab">Ticket History</button>
        <button className="tab">Document & Images</button>
        <button className="tab">Reverse QC</button>
      </div> */}

      {/* HISTORY */}

      <div className="tracking-history-wrapper" style={{ width: "100%" }}>




        {/* Record Communication */}

        {/* <div className="record-section">

          <label className="record-label">
            <input type="checkbox" />
            <span>Include Record Communication</span>
          </label>

          <span className="divider">|</span>

          <span className="attempt-text">
            Attempt Count
          </span>

          <span className="attempt-badge">
            1
          </span>

        </div> */}

        {/* Table */}

        <div className="history-table-card">

          <table className="tracking-history-table">

            <thead>
              <tr>
                <th>Status Date</th>
                <th> Status Time</th>
                <th>Activity Location</th>
                <th>Status & Scan Details</th>

              </tr>
            </thead>

            <tbody>

              {shipment.tempodData?.map((item, index) => (
                <tr key={index}>

                  <td>
                    {item.EntryDate}
                  </td>

                  <td>{item.EntryTime}</td>

                  <td>
                    {item.Details}
                  </td>

                  <td>
                    {item.Remark}
                  </td>



                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default TrackingResult;